import React, { FC, useEffect, useState, useContext} from 'react';
import { AEABatchGrid, AEAToast } from '@/components';
import { ValidationGroup } from 'devextreme-react/validation-group';
import { Container, Form, Row, Button } from 'reactstrap';
import { IFormProa } from '@interfaces/screens/form-proa.interface';
import { MainProaSubprojectFFRRPresenter } from '../../../../../../presenters/screens/form-proa-ffrr.presenter'
import storeContext from '@/context/store-context';
import styles from '../form-proa-subproject-ffrr.module.scss';
import ErrorTable from '@/components/ui/aea-error-table/aea-error-table';
import { Utilities } from "@utils";
export interface ICounterpartsFFRR{
    step1: any;
    step2: any;
    stepSDC: any;
    switchForm: boolean;
    dataColumns: any;
    index?: number;
    endDate: Date;
    alertEndDate: boolean;
    setStepSDC(stepSDC: any): void;
    getWarningMsg(): void;
    handleSwitch(): void;
}

const { StoreContext } = storeContext;
const CounterpartsFFRR: FC<ICounterpartsFFRR> = (props) => { 

    const [counterpartsProps, setCounterpartsProps] = useState(null);
    const [readOnly, setReadOnly] = useState(false);
    const context = useContext(StoreContext);

    const [stepData, setStepData] = useState(null);
    const [refresh, setRefresh] = useState(false);

    const view: IFormProa = {      
        state:{       
            endDate: props.endDate,     
            dataColumns: props.dataColumns,
            readOnly: readOnly,
            handleSwitch: props.handleSwitch,
            setFirstDataGridProps: setCounterpartsProps,
            setReadOnly: setReadOnly,
        },  
        setStepSDC: props.setStepSDC,      
        counterpartsData: props.stepSDC,
        implementersData: props.step2,
    }

    let validationGroup: ValidationGroup;
    const presenter = new MainProaSubprojectFFRRPresenter(view);

    useEffect(() => {        
        setCounterpartsProps(null);
        setRefresh(refresh => !refresh)
    }, [props.endDate])

    useEffect(()=>{
        const init = async () => {
            let sdcData = await presenter.initStepSDC();
            props.setStepSDC(sdcData)
        }
        if(props.stepSDC === undefined) init()
    },[props.switchForm, props.stepSDC]);

    useEffect(()=>{
        presenter.initializeStepSDC();
    },[props.stepSDC, presenter.currentBudgetStartDate, props.dataColumns, refresh]);

    useEffect(() => {
        if(!Utilities.isNullEmptyObject(counterpartsProps)) getStepData()
    }, [props.step2, props.stepSDC, counterpartsProps])

    const getStepData = () => {
        setStepData(
            <Row className={styles.gridRow}>
                <AEABatchGrid {...counterpartsProps} checkContent currentData={props.stepSDC !== undefined} onCellPreRender={presenter.onCellPreRender}></AEABatchGrid>
            </Row>
        )
    }

    if (Utilities.isNullEmptyObject(props.step1)) return ( <> {props.getWarningMsg()} </> )

    const render = () => {     
        return (
            <Container fluid={true}>
                <Form>
                    <ValidationGroup ref={ref => validationGroup = ref}>
                        {(counterpartsProps?.gridProps?.id && !!stepData && props.stepSDC !== undefined && !props.alertEndDate) && 
                            <ErrorTable 
                                paintColumn
                                gridId={counterpartsProps?.gridProps?.id} 
                                showAlerts={!props.alertEndDate}
                                checkFunction={presenter.checkEndDate}
                            />
                        }
                        {!!stepData && stepData}
                    </ValidationGroup>
                </Form>  
                <Row className={styles.gridRow}>
                {!readOnly ?
                    <Button className={styles.saveButton}
                        disabled={props.stepSDC === undefined}
                        onClick={(e) => {
                            e.preventDefault();
                            setTimeout(() => {
                                if (validationGroup.instance.validate().isValid) {
                                    presenter.saveStepSDC();
                                }
                            }, 500);
                        }}>{presenter.currentLabels.get('Guardar')}
                        </Button>
                    :<div></div>
                }
                    <Button onClick={(e) => {context.history.push('/proyecta/proa')}}>
                        {presenter.currentLabels.get('Cancelar')}
                    </Button>
                </Row> 
                {counterpartsProps && <AEAToast gridDataId={counterpartsProps.gridProps.id} currentLabels={presenter.currentLabels} ></AEAToast>}
            </Container>
        )       
    }    
    return render();
}
export default CounterpartsFFRR;

